var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"400px","background-color":"#fff","padding":"15px"},attrs:{"id":"by_function"}})}
var staticRenderFns = []

export { render, staticRenderFns }